// Layout
const VerticalLayout = () => import('@/layouts/VerticalLayout')

const faqsList = () => import('./views/list')

// start routes
export default [
  {
    path: '/faq',
    name: 'faq',
    component: VerticalLayout,
    children: [{
      path: '',
      name: 'faq',
      component: faqsList,
      meta: { name: 'faq', userType: 'provider', serviceTypes: 'all' }
    }]
  }
]
